import { render } from "./ContentQualityPage.vue?vue&type=template&id=602c2b5c&scoped=true"
import script from "./ContentQualityPage.vue?vue&type=script&lang=js"
export * from "./ContentQualityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602c2b5c"]])

export default __exports__